



























import Vue from 'vue';
import ScheduleCustomMsg from './ScheduleCustomMsg.vue';
import ScheduleTplMsg from './ScheduleTplMsg.vue';
import { DelayMode } from '@/rule/models/ScheduleDelay';
import { EventTriggered } from '@/rule/models/ScheduleRuleContext';
import { ScheduleEventType } from '@/rule/models/ScheduleEventParam';
import { WxTpl, ScheduleMsg, ScheduleMsgDisplayInfo, textToHtml } from '../../../models/ScheduleMsg';
import { CustomerMsg } from '../../../../customer/models/CustomerMsg';
import massClient from '@/mass/apis';
import scheduleRuleVuex from '../../../vuex/common';


export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    ScheduleCustomMsg,
    ScheduleTplMsg,
  },
  props: {
    eventTriggered: {
      type: Object as () => EventTriggered,
    },
    scheduleMsg: {
      type: Object as () => CustomerMsg,
    },
    delayMode: {
      type: Number,
    },
  },
  data() {
    return {
      DelayMode,
      initData: {},
    };
  },
  methods: {
    updateMsg(info: ScheduleMsgDisplayInfo) {
      this.$emit('updateMsg', info);
    },
  },
  computed: {
    customMsgEnabled(): boolean {
      const et = this.eventTriggered && this.eventTriggered.eventType;
      return et === ScheduleEventType.Follow || et === ScheduleEventType.RemarkAppended;
    },
    tranProps(): Array<any> {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        if (p.builtIn) {
          p.fieldName = '\\${' + p.fieldName + '}';
        } else {
          p.fieldName = '\\${privateProps.' + p.fieldName + '}';
        }
        return p;
      });
    },
    wxTpl(): WxTpl | undefined {
      const msg: ScheduleMsg = this.scheduleMsg as any;
      return msg && msg.WxTpl;
    },
    wxTplId(): string | undefined {
      const msg: ScheduleMsg = this.scheduleMsg as any;
      return msg && msg.WxTpl && msg.WxTpl.templateId;
    },
  },
  mounted() {
    const msg = this.scheduleMsg;
    if(msg && msg.WxNews) {
      let snap0 = msg.WxNews.snapshot[0];
      if(!snap0.thumb) {
        snap0 = {
          subject: snap0.title,
          thumb: snap0.picurl,
          gmtCreate: snap0.gmtCreate,
        };
      }
      this.initData = {
        contentType: 'NEWS',
        body: {
          news: snap0,
        },
      }
    } else if(msg && msg.WxImage) {
      this.initData = {
        contentType: 'IMAGE',
        body: {
          image: msg.WxImage,
        },
      }
    } else if(msg && msg.WxCard && msg.WxCard.cardId) {
      massClient.getCouponByCard({
        cardId: msg.WxCard.cardId,
      }).success((r: any) => {
        this.initData = {
          contentType: 'COUPON',
          body: {
            card: r.coupon,
          },
        };
      });
    } else if(msg && msg.WxCard && msg.WxCard.cardText) {
      this.initData = {
        contentType: 'COUPON',
        body: {
          cardText: msg.WxCard.cardText,
        },
      }
    } else if(msg && msg.WxText) {
      this.initData = {
        contentType: 'TEXT',
        body: {
          text: textToHtml(msg.WxText.text, this.tranProps),
          propConfigs: msg.WxText.propConfigs,
        },
      }
    }
  },
});
